function checkAll(checkAllElementName) {
  var checkAllElement = document.getElementById(checkAllElementName);
  var frm = checkAllElement.form;
  var els = frm.elements;
  for(var i=0; i<els.length; i++) if(els[i].getAttribute('checkAllElementName') == checkAllElementName) {
    if(!els[i].disabled) {
      if(checkAllElement.checked) {
        els[i].checked = true;
      } else {
        els[i].checked = false;
      }
    }
  }
  if (window.event) window.event.cancelBubble = true;
  return true;
}

function updateCheckAll(checkAllElementName) {
  var checkAllElement = document.getElementById(checkAllElementName);
  var checkableName = checkAllElement.checkableName;
  var frm = checkAllElement.form;
  var els = frm.elements;
  var checkAll = true;
  for(var i=0; i<els.length; i++) {
    if(els[i].getAttribute('checkAllElementName') == checkAllElementName) {
      if(!els[i].disabled) {
        if(!els[i].checked) {
          checkAll = false;
          break;
        }
      }
    }
  }
  checkAllElement.checked = checkAll;
  if (window.event) window.event.cancelBubble = true;
  return true;
}
